import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import {Box} from '@mui/material';
import {  memo  , useCallback , useState , useRef} from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Button from '@mui/material/Button';
import { useTranslation } from "react-i18next";
import {isRestaurant, isStation, isToilet, nl2br} from "../constants.js";
import {getImagePaths , slickSettingsCard} from "../../components/constants.js";
import { Link } from 'react-router-dom'

import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import SlackImage from "../../components/modal/slackImage.js";
import { useAudio }  from "../../hooks/useAudio.ts";
import ShareButtonX from "..//button/ShareButtonX.js";
import LinkCopyButton from "..//button/LinkCopyButton.js";
import {getLink} from "../../utils/UrlUtil.js";

/**
 * 以下のカテゴリで共有
 *  ・レストラン
 *  ・トイレ
 *  ・駅
 */
const MapCardStation = memo((props) => {
    const {data , resetMarker , isRouteEnabled , inRouteGuid , toggleRouteGuid, modalOpen} = props;
    const [isOpenDescription , setIsOpenDescription] = useState(false);
    const { t } = useTranslation();

    //--- 画像モーダル
    const [showModal , setShowModal] = useState(false);
    const selectedSlackImgUrl = useRef(null);
    const openSlackModal = (index, url) => {
       selectedSlackImgUrl.current = url;
       setShowModal(true);
    };
    const closeSlackModal = (index, url) => {
       selectedSlackImgUrl.current = "";
       setShowModal(false);
    };
    // 画像モーダル ---*/

    //---- 音声ガイド　---
    const { playSound, stopSound, currentAudioSrc } = useAudio();  

    const toggleOpenDescription = () => {
        setIsOpenDescription(!isOpenDescription);
    };

    const clickBtnRouteGuid = () => {
        setIsOpenDescription(false);
        toggleRouteGuid(!inRouteGuid);
    }

    const close = () => {
        setIsOpenDescription(false);
        stopSound();
        resetMarker();
    }
    const nl2comma = useCallback((str) => {
        return str.replaceAll("¥/", "、");
    },[]);

    const canDisplayDescription = useCallback((data) => {
        if(!data){
            return false;
        }
        return data.description !== '';
    },[]);

    const soundStart = () => {
        let src = "/assets/sound/" + data.sound;
        playSound(src);
    };
    const soundStop = () => {
        stopSound();
    };
    const isPlayingSound = (history) => {
        return currentAudioSrc != ""
    }

    if(data && data.name){
    let paths = getImagePaths(data.path);
    return <>
    <Card className={"stationCard mapCard"} sx={{
       position: 'absolute',
       bottom: '1%',
       right:'1%',
       width:'98%',
       zIndex:10000     
    }}>
    <Box className='head-content'>
        <Typography component="div" variant="h5" className="title">
            {data.name}
        </Typography>
        <IconButton className={"close"} size="large">
            <CloseIcon onClick={close} />
        </IconButton>
    </Box>
    <Box className="share-button-row">
        <span className='category-label text'>{t("category." + data.category)}</span>
        <div className="img-wap">
            <ShareButtonX 
                path={getLink(data)}
                text={data.name + ' / ' + t("meta.title")}
            />
            <LinkCopyButton 
                path={getLink(data)}
            />
        </div>
    </Box>
    <hr className={"hr95"} />

    {!inRouteGuid &&
    <Box sx={{display:'flex'}}>
        <Box sx={{ display: 'block'}}>
            <CardContent className="card-content" sx={{ flex: '1 0 auto' }}>
                <div className="slick-wrap">
                    {paths.length >= 1 &&
                    <Slider {...slickSettingsCard}>
                    {
                        paths.map((path, index) =>{
                            return <Box className="img-carousel-wrap" key={index} onClick={() => openSlackModal(index, "/assets/images/descriptions/" + path)}>
                                <img className="img-carousel" src={"/assets/images/descriptions/" + path} />
                                </Box>
                        })
                    }
                    </Slider>
                    }
                </div>

                {isRestaurant(data) && !inRouteGuid &&  
                <>
                    <Box className='description'>
                        {nl2comma(data.open)}
                    </Box>
                    <Box className='description'>
                        {nl2comma(data.shopInfo)}
                    </Box>
                </>
                }

                {isToilet(data) && !inRouteGuid &&  
                <>
                    <Typography variant="subtitle1" component="div" sx={{ color: 'text.secondary', overflowWrap: 'break-word' }}>
                        <div dangerouslySetInnerHTML={{__html: nl2br(data.catchcopy)}}></div>
                    </Typography>
                </>
                }

                {isStation(data) && !inRouteGuid &&  
                <div className="line-container">
                    {
                    data.lineIcon.map((imgPath, index) =>{
                        return <div className="card">
                            <div className="card__content">
                            <CardMedia
                                component="img"
                                sx={{ height:"1rem" }}
                                image={"/assets/images/descriptions/" + imgPath}
                            />                               
                            <p>{data.lineName[index]}</p>
                            </div>
                        </div>
                    })
                    }
                </div>
                }
                {(data.insta360 || data.sound) && 
                <Box className='btnWrap'>
                    {data.insta360 && 
                    <Button variant="contained" onClick={modalOpen}>{t("360image.button")}</Button>
                    }
                    {data.sound && 
                    <>
                    {isPlayingSound(data)? (
                        <Button variant="contained" onClick={soundStop}>停止</Button>
                    ) : (
                        <Button variant="contained" onClick={soundStart}>音声ガイド</Button>
                    )}
                    </>
                    }
                </Box>
                }
                {
                canDisplayDescription(data.description) && !inRouteGuid &&
                <>
                <hr className={"hr98 mtb10"} />
                <Box className='description'>
                    <div dangerouslySetInnerHTML={{__html: nl2br(data.description)}}></div>
                </Box>
                </>
                }
            </CardContent>
        </Box>
    </Box>
    }
    <Box className='btnWrap'>
        {isRouteEnabled &&
        <Button variant="contained" onClick={clickBtnRouteGuid}>
            {inRouteGuid?<>{t("common.btn_off_Route")}</>:<>{t("common.btn_on_Route")}</>}
        </Button>
        }

        {
        //外部リンクがあれば詳細ボタン
        data.link && 
        <Link to={data.link} target="_blank">
            <Button variant="contained">
                {t("common.btn_open_detail")}&nbsp;<OpenInNewIcon></OpenInNewIcon>
            </Button>
        </Link>
        }
    </Box>
    </Card> 
    {showModal && !isStation(data) &&
        <SlackImage isOpen={showModal} modalClose={closeSlackModal} url={selectedSlackImgUrl.current}></SlackImage>
    }
    </>;
    }
});
export default MapCardStation
